import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog'
import React, { FC, useEffect, useMemo, useState } from 'react'
import { tawreedTranslationService } from '../../../../common/translations';
import { useHistory } from 'react-router-dom';
import { TopUpEligibleResultDto, WalletService } from '../../domain';

export interface ConfirmDialogProps {
    visible: boolean;

    hide: () => void;

    accept: () => void;
    topUpEligibleResult?: TopUpEligibleResultDto;
}

export const ConfirmDialog: FC<ConfirmDialogProps> = ({ visible, hide, accept, topUpEligibleResult }) => {

    const [data, setData] = useState<TopUpEligibleResultDto>();

    const ConfirmDialogFooter = () => {
        return (<div>
            <Button label={tawreedTranslationService.translate('lbl_cancel')} icon="pi pi-times" onClick={hide} className="p-button-text" disabled={false} />
            <Button label={tawreedTranslationService.translate('lbl_continue')} icon="pi pi-check" onClick={() => {
                accept()
                hide();
            }} className="p-button-success" />

        </div>);
    }
    const service: WalletService = useMemo(() => new WalletService(), []);


    // useEffect(() => {
    //     service.getDetails(storeProductRawId).then((res) => {
    //         setData(res);
    //         if (res.matches && res.matches.length) {
    //             let item = (res.status === IStoreProductRawStats.EXACT_MATCH) ? res.matches[0] : (res.matches.find(el => el.status === 'MANUAL') ?? undefined);
    //             setSelectedItem(item);
    //         }
    //     })
    // }, [service, storeProductRawId])


    // const itemTemplate = (item: StoreRawMatchDto) => {
    //     return (
    //         <div onClick={() => { setSelectedItem(item) }} className={`flex flex-wrap p-2 align-items-center gap-3 ${selectedItem && selectedItem.storeProductRawMatchId === item.storeProductRawMatchId ? "selectedBonus" : ""}`}>
    //             <ImageViewer baseImage={item.baseImage ?? ""} secondImage={item.secondImage ?? ""}></ImageViewer>
    //             <div className="flex-1 flex flex-column gap-2 xl:mr-8">
    //                 <span className="font-bold">{item.displayName}</span>
    //                 <div className="flex align-items-center gap-2">
    //                     <i className="pi pi-tag text-sm"></i>
    //                     <Link to={Routes.ProductsDetails.replace(':id', item!.productId!.toString())} target='_blank' >{item.internationalCode}</Link>
    //                 </div>
    //             </div>
    //             <div>
    //                 <span className="font-bold text-900"><Knob size={70} value={+(item.score! * 100).toFixed(0)} readOnly /></span>
    //             </div>
    //         </div>
    //     );
    // };




    return (
        <Dialog maximizable resizable style={{ minWidth: '70%' }} header={tawreedTranslationService.translate("tawreed_dialog_confirm_hdr")} visible={visible}
            footer={<ConfirmDialogFooter />} onHide={hide} draggable={false} position="top" closable={true} closeOnEscape={true}>
            <React.Fragment>
                <div className="field-tawreed field col-6 md:col-6">
                    <label>{tawreedTranslationService.translate("lbl_wallet_transaction_amount")}</label>
                    <br />
                    <span>{topUpEligibleResult?.amount}</span>
                </div>
                <div className="field-tawreed field col-6 md:col-6">
                    <label>{tawreedTranslationService.translate("lbl_topup_cashback")}</label>
                    <br />
                    <span>{topUpEligibleResult?.cashback}</span>
                </div>
                <div className="field-tawreed field col-6 md:col-6">
                    <label>{tawreedTranslationService.translate("lbl_topup_fees")}</label>
                    <br />
                    <span>{topUpEligibleResult?.fees}</span>
                </div>
                <div className="field-tawreed field col-6 md:col-6">
                    <label>{tawreedTranslationService.translate("lbl_topup_fees_tax")}</label>
                    <br />
                    <span>{topUpEligibleResult?.feesTax}</span>
                </div>

            </React.Fragment>
        </Dialog>
    )
}
